import Container from "./Container";
import { useAuth } from "hooks/Auth";
import React, { Fragment, useState, useEffect } from "react";

export default function AdminScreen(props) {
    const auth = useAuth();
    const [hasAccess, setHasAccess] = useState(false);

    useEffect(() => {
        if (auth.isAuthenticated && auth?.user.is_admin) {
            setHasAccess(true);
        } else {
            setHasAccess(false);
        }
    }, [auth]);

    if (hasAccess) {
        return <Fragment>{props.children}</Fragment>;
    }

    return (
        <Container>
            <div className="mx-auto max-w-3xl rounded-md shadow-sm bg-white p-4 space-y-4">
                <h1 className="text-3xl font-bold text-gray-600">Oh no!</h1>
                <hr />
                <p className="prose-sm">You may not have access to this.</p>
                <p className="prose-sm">
                    If you have any questions, please contact{" "}
                    <a
                        href="https://snworks.zendesk.com/hc/en-us"
                        target="_blank"
                        className="text-green-600 underline"
                        rel="noopener noreferrer"
                    >
                        support
                    </a>
                    .
                </p>
            </div>
        </Container>
    );
}
